<div>
    <dx-data-grid
        bds-grid
        id="bdsReportGrid"
        [dataSource]="gridSource"
        height="80vh"
        minHeight="200px"
        [allowColumnResizing]="true"
        [columnAutoWidth]="true"
        [showBorders]="true"
    >
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

        <dxi-column dataField="car_init" caption="Car Init"></dxi-column>
        <dxi-column dataField="car_no" caption="Car No."></dxi-column>
        <dxi-column
            dataField="ship_date"
            caption="Ship Date"
            format="MM/dd/yy"
            dataType="date"
        ></dxi-column>
        <dxi-column dataField="comm_code" caption="Comm Code"></dxi-column>
        <dxi-column dataField="comm_name" caption="Comm Name"></dxi-column>
        <dxi-column dataField="comm_class" caption="Comm Class"></dxi-column>
        <dxi-column dataField="comm_compart" caption="Compart"></dxi-column>
        <dxi-column dataField="comm_amt" caption="Amount"></dxi-column>
        <dxi-column dataField="comm_units" caption="Units"></dxi-column>
        <dxi-column dataField="loc_city" caption="Location"></dxi-column>
        <dxi-column dataField="loc_state" caption="St"></dxi-column>
        <dxi-column dataField="dest_city" caption="Destination"></dxi-column>
        <dxi-column dataField="dest_state" caption="St"></dxi-column>
        <dxi-column dataField="sight_code" caption="Code"></dxi-column>
        <dxi-column dataField="road" caption="Road"></dxi-column>
        <dxi-column dataField="le" caption="L/E"></dxi-column>
        <dxi-column
            dataField="clm_date_time"
            caption="CLM Date"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="fleet_id" caption="Fleet"></dxi-column>
        <dxi-column dataField="business_group" caption="Business Group"></dxi-column>
        <dxi-column dataField="car_status" caption="Car Status"></dxi-column>
        <dxi-column dataField="trip_status" caption="Trip Status"></dxi-column>
        <dxi-column dataField="cust_no" caption="Cust No."></dxi-column>
        <dxi-column dataField="cust_name" caption="Customer"></dxi-column>
        <dxi-column dataField="csr_no" caption="CSR No."></dxi-column>
        <dxi-column dataField="sales_rep" caption="Sales Rep"></dxi-column>
        <dxi-column dataField="hot_list_flag" caption="Hot List"></dxi-column>
        <dxi-column dataField="hot_list_flag_mech" caption="HL Mech"></dxi-column>
        <dxi-column dataField="hot_list_flag_leas" caption="HL Leas"></dxi-column>
        <dxi-column dataField="trouble_yorn" caption="Trouble"></dxi-column>
        <dxi-column dataField="COMMENTS" caption="Comments"></dxi-column>
        <dxi-column dataField="ecomment_code" caption="Expeditor Comment"></dxi-column>
        <dxi-column dataField="comm_ref1" caption="Comm Ref 1" [visible]="false"></dxi-column>
        <dxi-column dataField="comm_ref2" caption="Comm Ref 2" [visible]="false"></dxi-column>
        <dxi-column dataField="comm_ref3" caption="Comm Ref 3" [visible]="false"></dxi-column>
        <dxi-column dataField="comm_ref4" caption="Comm Ref 4" [visible]="false"></dxi-column>
        <dxo-summary>
            <dxi-total-item
                summaryType="count"
                displayFormat="Total Count: {0}"
                alignment="right"
            ></dxi-total-item>
        </dxo-summary>
    </dx-data-grid>
</div>
